<script lang="ts">
import { RouterView } from 'vue-router';
import { usePayloadStore } from '@/stores/payload';
import { Vue, Options } from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
@Options({
  components: {
    RouterView
  }
})
export default class App extends Vue {
  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  mounted() {
    this.loadingResponse = this.payloadStore.payload.loadingResponse;
  }

  @Watch('payloadStore.payload')
  public onSelectedModuleChange() {
    this.loadingResponse = this.payloadStore.payload.loadingResponse;
  }
}
</script>

<template>
  <RouterView />
  <v-overlay :model-value="loadingResponse" class="align-center justify-center">
    <v-progress-circular indeterminate size="64" color="primary-main"></v-progress-circular>
  </v-overlay>
</template>

<style scoped></style>
